import React from "react";
import { Edit } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { colors } from "../../utils/colors";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  boxStyle: {
    backgroundColor: colors.PRIMARY,
    padding: "8px",
    display: "flex",
    alignItems: "center",
    borderRadius: "8px",
    cursor: "pointer",
  },
});

function TitleBar({ name, handleToggle }) {
  const navigate = useNavigate();

  const classes = useStyles();

  const { role } = useSelector((state) => state.userDetailsReducer);

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          fontSize: { md: "20px", xxl: "40px" },
        }}
        color="initial"
      >
        {name}
      </Typography>
      {(role === "admin" || role === "super") && (
        <Box onClick={handleToggle} className={classes.boxStyle}>
          <Edit sx={{ color: "white" }} />
        </Box>
      )}
    </Box>
  );
}

export default TitleBar;
